/* Return to the exact collection/search list, including progressive pagination. */
(() => {
  const KEY = 'kp:list-origin:v1', RESTORE = 'kp:list-return:v1';
  const market = path => path.match(/^\/([a-z]{2}-[a-z]{2})(?:\/|$)/i)?.[1].toLowerCase() || '';
  function validContext(saved, current, now = Date.now()) {
    try {
      const here = new URL(current), list = new URL(saved.url, here), product = new URL(saved.product, here);
      return saved.time <= now && now - saved.time < 1800000 && list.origin === here.origin && product.origin === here.origin &&
        market(list.pathname) === market(here.pathname) && market(product.pathname) === market(here.pathname) &&
        /^(?:\/[a-z]{2}-[a-z]{2})?\/(?:collections\/[^/]+|search)\/?$/i.test(list.pathname) &&
        /\/products\/[^/]+\/?$/.test(product.pathname);
    } catch (_) { return false; }
  }
  function isSearchContext(saved, current) {
    if (!validContext(saved, current)) return false;
    const list = new URL(saved.url, current);
    return /\/search\/?$/i.test(list.pathname) && !!list.searchParams.get('q')?.trim();
  }
  if (typeof module === 'object' && module.exports) { module.exports = { validContext, isSearchContext }; return; }
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  function consumeRestore() {
    const saved = read(RESTORE);
    if (!validContext(saved, location.href) || saved.url !== location.pathname + location.search) return null;
    try { sessionStorage.removeItem(RESTORE); } catch (_) {}
    return saved;
  }
  window.KpListContext = { consumeRestore };
  const pending = read(RESTORE);
  if (validContext(pending, location.href) && pending.url === location.pathname + location.search) {
    // Also suppress the filtered-entry auto-scroll before the collection initializes.
    history.replaceState({ ...history.state, kpCollection: pending }, '', location.href);
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link?.closest('[data-product-container], .m-search-result') || link.origin !== location.origin || !/\/products\//.test(link.pathname)) return;
    const saved = { url: location.pathname + location.search, product: link.pathname,
      page: window.MinimogTheme?.Collection?.currentPage || 1, scroll: window.scrollY,
      searchVisible: Number(document.querySelector('.m-search-result')?.dataset.kpVisible || 12), time: Date.now() };
    if (validContext(saved, location.href)) {
      write(KEY, saved);
      if (link.closest('.m-search-result')) history.replaceState({ ...history.state, kpSearch: saved }, '', location.href);
    }
  }, true);
  function init() {
    const link = document.querySelector('[data-kp-back-results]');
    if (!link) return;
    let saved = history.state?.kpListOrigin;
    if (!validContext(saved, location.href)) {
      saved = read(KEY);
      if (!validContext(saved, location.href)) return;
      try {
        const referrer = new URL(document.referrer);
        if (referrer.origin !== location.origin || referrer.pathname + referrer.search !== saved.url) return;
      } catch (_) { return; }
    }
    if (saved.product !== location.pathname) return;
    // Collection browsing already has breadcrumbs; only a real search gets this extra row.
    if (!isSearchContext(saved, location.href)) return;
    history.replaceState({ ...history.state, kpListOrigin: saved }, '', location.href);
    link.href = saved.url;
    link.hidden = false;
    link.addEventListener('click', () => write(RESTORE, { ...saved, time: Date.now() }));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
